<template>
<div class="container-guest p-5 d-flex flex-column align-items-center">

    <div class="back-btn-group-forgotpassword" @click="goBack">
        <img class="green-back-btn" src="@/assets/images/ic_green_arrow.svg">
    </div>
      <h4 class="titleFP">Forgot Password?</h4>


    <div class="text-info">
    <p class="text-gray forgot-password-sub-title">Enter your email below and we'll send you a link to reset your password.</p>
    </div>

  <img class="img-logo-forgot-password" src="@/assets/images/ic_forgot_password.svg">
    <form class="w-100 form-fnc" autocomplete="off">

        <div class="input-group " style="margin-bottom: 60px;">
            <img class="img-icon" src="@/assets/images/au-icon-email.svg">
            <input type="email" class="form-control" placeholder="Email" v-model="email"
                   v-bind:class="{ 'is-invalid': attemptSubmit && (missingEmail || invalidEmailFormat) }">
            <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'email'">{{ error.text }}</div>
        </div>

        <button @click="validateForm" class="btn btn-block btn-fnc">SENT RESET LINK</button>

        <flash-message transitionIn="animated swing"></flash-message>
    </form>

    <div class="plainText">  Don't have an account?
    <b-link :to="{ name: 'register' }" class="link-small" >
       <a class="one text-green" href="#" >Sign Up Free</a>
    </b-link>
  </div>

  <div class="plainText">    Remember password?
    <b-link :to="{ name: 'login' }" class="link-small">
      <a class="one text-green" href="#" >Login</a>
    </b-link>
  </div>

    <vapp-alertview v-if="is_show_overlay" :viewForgetPassword="true"></vapp-alertview>

</div>
</template>

<script>

    import cryptojs from 'crypto-js'

export default {
  data: function() {
    return {
      active:false,
      errors: [],
      email: null,
      sic_code: 2,
        attemptSubmit: false,
        client_id: cryptojs.MD5(Math.random()).toString(),
        is_show_overlay: false,
    };
  },
    computed: {
        missingEmail: function () {
            if (!this.email) { return true; } else { return false; }
        },
        invalidEmailFormat: function () {
            if (!this.validEmail(this.email)) { return true; } else { return false; }
        },
    },
    created() {
        this.$root.$on('dismiss-alert-view-fp', vars => {
            this.is_show_overlay = false;
            this.goToRequestPin();
        })
    },
  methods: {

      goBack() {
          window.history.length > 1 ?
              this.$router.go(-1) :
              this.$router.push('/login')
      },
      goToRequestPin() {
        this.$router.push({name: "requestPin", params:{email: this.email}})
      },
    sendResetLink(email) {
        this.$root.$emit('show-loading', true);
        this.axios({
            method: 'get',
            url: '/pin',
            params:{
              'email':email
            }
          }).then(response => {

          /* should push to reset password screen*/
          this.$root.$emit('show-loading', false);
          this.is_show_overlay = true;

          }).catch(error => {
          this.$root.$emit('show-loading', false);
          this.$generalAPIErrorHandling(error, this.$router);
        })
    },
      validateForm: function (event) {
          this.errors = [];
          this.attemptSubmit = true;

          if (this.missingEmail) {
              this.errors.push({id: 'email', text: "This field is compulsory"});
          }
          else if (this.invalidEmailFormat) {
              this.errors.push({id: 'email', text: 'Valid email required.'});
          }

          if(!this.errors.length) {

              event.preventDefault();
              this.sendResetLink(this.email);
          } else {
              event.preventDefault();
          }

      },
    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
  },

};
</script>
